import React from 'react';
import { Button, Confirm, Grid, Header, Table } from 'semantic-ui-react';
import { performOrderStatusPost } from '../../actions/Order';
import Review from './Review';
import { connect } from 'react-redux';

class OrderListUser extends React.Component {
    state = {
        confirmOpen: false,
        propertyToDelete: 0,
        reviewActive: false,
    };
    setStatus = (status) => {
        if(status === 0) {
            return 'warning';
        } else if(status === 1) {
            return 'positive';
        }
        else if(status === -1) {
            return 'negative';
        }
    }

    openReview = () => {
        this.setState({ reviewActive: true });
    };

    closeReview = () => {
        this.setState({ reviewActive: false });
    };

    handleConfirm = (key, value) => {
        this.setState({ confirmOpen: false });
        const fields = {
            'id' : this.state.propertyToDelete,
            'status': -1
        }
        this.props.performOrderListPost(fields)
    };

    handleCancel = () => this.setState({ confirmOpen: false });

    confirmOpen = (e) => {
        const propertyToDelete = e.target.value;
        this.setState({ propertyToDelete:propertyToDelete,  confirmOpen: true })
    }

    render () {
        const list = this.props.list?? [];
        const confirmOpen = this.state.confirmOpen;
        return (
            <Grid>
                <Header as='h1'
                        content={'My order list'}
                        textAlign='center'/>
                <Table celled>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Restaurant</Table.HeaderCell>
                            <Table.HeaderCell>Date</Table.HeaderCell>
                            <Table.HeaderCell>Order data</Table.HeaderCell>
                            <Table.HeaderCell>Status</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {
                            Object.keys(list).map((key) => (
                                <Table.Row>
                                    <Table.Cell>
                                        {list[key]['restaurant']['name']}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {new Intl.DateTimeFormat("en-GB", {
                                        hour: 'numeric', minute: 'numeric',
                                        year: "numeric",
                                        month: "long",
                                        day: "2-digit"
                                    }).format(new Date(list[key]['orderDate']['date']))}
                                    </Table.Cell>
                                    <Table.Cell>
                                       Name: {list[key]['user']['username']},
                                       Guests: {list[key]['guests']}
                                    </Table.Cell>
                                    <Table.Cell className={this.setStatus(list[key]['status'])}>
                                        {list[key]['statusText']}
                                        {
                                            list[key]['status'] >= 1 ? (
                                                this.state.reviewActive ? (
                                                        <Review restId={list[key]['restaurant']['id']}
                                                                closeReview={this.closeReview}/>) :
                                                    <Button color='green' className='checkout-button'
                                                            onClick={this.openReview}>Write a
                                                        review</Button>
                                            ) : ('')
                                        }
                                        {
                                            list[key]['status'] === 0 || list[key]['status'] === 1 ? (
                                                <>
                                                    <Button value={list[key]['id']}  color='red' className='decline-button'
                                                            onClick={this.confirmOpen}>Decline</Button>
                                                    <Confirm
                                                        open={confirmOpen}
                                                        onCancel={this.handleCancel}
                                                        onConfirm={this.handleConfirm}
                                                    />
                                                </>
                                            ) : ('')
                                        }

                                    </Table.Cell>
                                </Table.Row>
                            ))
                        }
                    </Table.Body>
                </Table>
            </Grid>
        );
    }
}

const mapStateOrderList= (state) => {
    return {
        order: state.order
    };
};

const mapDispatchOrderList = (dispatch) => (
    {
        performOrderListPost: (fields) => (
            dispatch(performOrderStatusPost(fields))
        )
    }
);

const OrderListUserDisplay = connect(
    mapStateOrderList,
    mapDispatchOrderList
)(OrderListUser);

export default OrderListUserDisplay;
